import React from 'react';
import styles from './Leaders.module.css';
import leader1 from "../../images/leader/1stImage.png";
import leader2 from "../../images/leader/2ndImage.png";
import leader3 from "../../images/leader/3rdImage.png";
import leader4 from "../../images/leader/4thImage.png";
import leader5 from "../../images/leader/5thImage.png";
import leader6 from "../../images/leader/8th.png";


// import leader2 from 'https://imgs.search.brave.com/avQbo97PWopkX9lPCY0pOY_ZFnfld80sUsgJl7uhvQA/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5pc3RvY2twaG90/by5jb20vaWQvNTE1/OTMwOTkzL3ZlY3Rv/ci9tYW4taGVhZC1h/bmQtc2hvdWxkZXJz/LXNpbGhvdWV0dGUt/d2l0aC1leGNhbG1h/dGlvbi1tYXJrLXZl/Y3Rvci5qcGc_cz02/MTJ4NjEyJnc9MCZr/PTIwJmM9ejVTNkxE/azNDRE9veDVqU00w/bVNDSXF4anNseEhV/WjN0VmlwS2xDTFdW/dz0';
// import leader3 from 'https://imgs.search.brave.com/avQbo97PWopkX9lPCY0pOY_ZFnfld80sUsgJl7uhvQA/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5pc3RvY2twaG90/by5jb20vaWQvNTE1/OTMwOTkzL3ZlY3Rv/ci9tYW4taGVhZC1h/bmQtc2hvdWxkZXJz/LXNpbGhvdWV0dGUt/d2l0aC1leGNhbG1h/dGlvbi1tYXJrLXZl/Y3Rvci5qcGc_cz02/MTJ4NjEyJnc9MCZr/PTIwJmM9ejVTNkxE/azNDRE9veDVqU00w/bVNDSXF4anNseEhV/WjN0VmlwS2xDTFdW/dz0';


const leaders = [
  { title: 'Bobby Bonser', subTitle : 'Director, CO, USA.', role: 'Director Sales Head', img: leader1 , text:"Bridging decades of automotive dealership expertise with cutting-edge AI innovation, Bobby leads the charge in delivering transformative tech solutions to the automotive space and beyond." },
  { title: 'Sneha Seth', subTitle : 'Experience supporting Microsoft & enterprise clients', role: 'Founder and CMO', img: leader2, text:"CMO with a sharp eye for emerging tech trends, leading go-to-market strategy and brand storytelling for AI products transforming automotive and other key sectors."},
  { title: 'Sanjay Soni', subTitle : 'Ex-Microsoft  |  Technology Leader', role: 'Chief Technology Officer', img: leader3 ,text:"Tech innovator specializing in scalable solutions, with a passion for driving digital transformation across industries."},
  // { title: 'Dhananjay Kumar', subTitle : 'NVIDIA Alumnus', role: 'Director', img: leader4 ,text:"Tech innovator specialising in scalable solutions, with a passion for driving digital transformation across industries."},
  { title: 'Pradyumn Thakur', subTitle : 'Patna, India  |  HRBP Leader', role: 'VP – HRBP', img: leader6, text:"Strategic HR leader driving talent acquisition, workforce planning, organizational growth, and human resource management to empower high-performing engineering and tech teams across ProvaanTech." },
  // { title: 'Vishal', subTitle : 'IIITM Gwalior Alumnus | AI & Technology Leader', role: 'Solution Architect', img: leader5,text:"Expert in designing end-to-end Al solutions that align tech innovation with real-world impact-driving digital transformation in Automotive, Fintech, Retail and beyond."},
];

const features = [
  { icon: '📌', text: 'Provaantech is a dynamic software engineering company delivering tailored IT solutions.' },
  { icon: '🌐', text: 'We serve industries like aerospace, finance, automotive, farming, media & more.' },
  { icon: '🧠', text: 'Our expert team solves complex challenges with deep tech knowledge and experience.' },
  { icon: '🚀', text: 'We harness AI, IoT, Blockchain, Smart Home tech, Data Science, Azure & AWS.' },
  { icon: '🔧', text: 'From hardware integration to secure digital platforms, we build future-ready systems.' },
  { icon: '🤝', text: 'Provaantech is your trusted partner in innovation, growth, and digital transformation.' },
];

const Leaders = () => {
  return (
    <>
    <section className={styles.container}>
      <h2 className={styles.heading}>Meet our leaders</h2>

      <div className={styles.grid}>
        {leaders.map((leader, idx) => (
          <div key={leader.title || idx} className={styles.card}>

            {/* Image Section */}
            <div className={styles.imageWrapper}>
              <img src={leader.img} alt={leader.title} />
            </div>

            {/* Name Strip */}
            <div className={styles.nameStrip}>
              <h3>{leader.title}</h3>
              <span>{leader.subTitle}</span>
            </div>

            {/* Content */}
            <div className={styles.content}>
              <h3 className={styles.title}>{leader.role}</h3>
              <p>{leader.text}</p>
            </div>

          </div>
        ))}
      </div>
    </section>
     <div className={styles.features}>
        {features.map((feature, idx) => (
          <div className={styles.featureBox} key={idx}>
            {/* <span className={styles.icon}>{feature.icon}</span> */}
            <span>{feature.text}</span>
          </div>
        ))}
      </div>
      </>
  );
};

export default Leaders;
